import img1 from "../../../assets/images/training/rating-image-1.png";
import img2 from "../../../assets/images/training/rating-image-2.png";
import moment from "moment";
import "./style.scss"
function RatingMilestoneTable({ milestones }: { milestones: [] }) {
  return (
    <div className="col col-lg-9 col-md-12 right">
      <div className="rating_details">
        <div className="top">
          <div className="image">
            <img src={img1} alt="" />
          </div>
          <div className="center">
            <div className="milestones">
              {milestones?.map((milestone: any, i: number) => (
                <span key={i} className={`milestone ${milestone?.completed ? "completed" : ""}`}></span>
              ))}
            </div>
            <div className="text">{milestones?.filter((milestone: any) => milestone?.completed)?.length} of {milestones?.length} milestones complete.</div>
          </div>
          <div className="image">
            <img src={img2} alt="" />
          </div>
        </div>

        <div className="rating_table">
          <table>
            <thead>
              <tr>
                <th>Milestones</th>
                <th>Total</th>
                <th>Progress</th>
                <th>Complete Data</th>
              </tr>
            </thead>
            <tbody>

              {milestones?.map((milestone: any, i: number) => (
                <tr key={i}>
                  <td style={{ minWidth: "280px" }}>
                    <label className="checkbox">
                      {milestone?.milestone} <input type="checkbox" checked={milestone?.completed} />
                      <span className="checkmark"></span>
                    </label>

                  </td>
                  <td>{milestone?.found}</td>
                  <td>{milestone?.progress}</td>
                  <td>{moment(milestone?.date).format("D/M/YYY")}</td>
                </tr>
              ))}

              {/* <tr>
                        <td>
                          <label className="checkbox">
                            20 hours of flight training (dual)
                            <input type="checkbox" />
                            <span className="checkmark"></span>
                          </label>
                        </td>
                        <td>02 Found</td>
                        <td>10%</td>
                        <td>8/8/2023</td>
                      </tr>
                      <tr>
                        <td>
                          <label className="checkbox">
                            10 hours of solo time
                            <input type="checkbox" />
                            <span className="checkmark"></span>
                          </label>
                        </td>
                        <td>08 Found</td>
                        <td>80%</td>
                        <td>8/8/2023</td>
                      </tr>
                      <tr>
                        <td>
                          <label className="checkbox">
                            3 hours of cross-country training in a single engine
                            airplane
                            <input type="checkbox" />
                            <span className="checkmark"></span>
                          </label>
                        </td>
                        <td>02 Found</td>
                        <td>33%</td>
                        <td>8/8/2023</td>
                      </tr>
                      <tr>
                        <td>
                          <label className="checkbox">
                            3 hours of night flight training in a single engine
                            airplane
                            <input type="checkbox" />
                            <span className="checkmark"></span>
                          </label>
                        </td>
                        <td>0 Found</td>
                        <td>0%</td>
                        <td>8/8/2023</td>
                      </tr>
                      <tr>
                        <td>
                          <label className="checkbox">
                            One night-time cross-country training flight of over
                            100NM distance in a single engine airplane
                            <input type="checkbox" checked />
                            <span className="checkmark"></span>
                          </label>
                        </td>
                        <td>40 Found</td>
                        <td>100%</td>
                        <td>8/8/2023</td>
                      </tr>
                      <tr>
                        <td>
                          <label className="checkbox">
                            10 night takeoffs (training) in a single engine
                            airplane
                            <input type="checkbox" />
                            <span className="checkmark"></span>
                          </label>
                        </td>
                        <td>0 Found</td>
                        <td>0%</td>
                        <td>8/8/2023</td>
                      </tr>
                      <tr>
                        <td>
                          <label className="checkbox">
                            10 night landings (training) to a full stop in a
                            single engine airplane
                            <input type="checkbox" />
                            <span className="checkmark"></span>
                          </label>
                        </td>
                        <td>0 Found</td>
                        <td>0%</td>
                        <td>8/8/2023</td>
                      </tr>
                      <tr>
                        <td>
                          <label className="checkbox">
                            3 hours of flight training by reference to
                            instruments in a single engine airplane
                            <input type="checkbox" />
                            <span className="checkmark"></span>
                          </label>
                        </td>
                        <td>02 Found</td>
                        <td>33%</td>
                        <td>8/8/2023</td>
                      </tr> */}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default RatingMilestoneTable